import React, { Component } from "react";
import axios from "axios";
import { Card, Grid } from "@mui/material";
import { Link, Navigate } from "react-router-dom";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";

export default class ArLevels extends Component {
  state = {
    rows: [],
    message: "",
    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      nextPage: null,
      prevPage: null,
      totalDocs: 0,
      limit: 20,
    },
    notification: false,
    noticolor: "success",
    per_page: 20,
    page_no: 1,
    redirect: false,
  };

  componentDidMount() {
    this.getAllLevels(this.state.page_no, this.state.per_page);
  }

  getAllLevels = (page = 1, limit = this.state.per_page) => {
    if (init() !== "success") {
      window.location.assign("/signin");
      return;
    }

    axios
      .get(`${Constants.getUrls.getAllArLevels}?page=${page}&limit=${limit}`)
      .then((resp) => {
        this.setState({
          rows: resp?.data?.data?.docs || [],
          pagination: resp?.data?.data || this.state.pagination,
          page_no: resp?.data?.data?.page || 1,
          notification: true,
          noticolor: "success",
          message: resp?.data?.message || "AR levels loaded.",
        });
        setTimeout(() => this.setState({ notification: false, message: "" }), 2500);
      })
      .catch((err) => {
        this.setState({
          notification: true,
          noticolor: "error",
          message: err?.response?.data?.message || "Error fetching AR levels",
        });
        setTimeout(() => this.setState({ notification: false, message: "" }), 2500);
      });
  };

  handleEntriesPerPageChange = (newLimit) => {
    this.setState({ per_page: newLimit }, () => this.getAllLevels(1, newLimit));
  };

  handlePageChange = (newPage) => {
    this.getAllLevels(newPage, this.state.per_page);
  };

  handleDelete = (id) => {
    axios
      .delete(`${Constants.deleteUrls.deleteArLevel}${id}`)
      .then((resp) => {
        this.setState({
          notification: true,
          noticolor: "success",
          message: resp?.data?.message || "AR level deleted.",
        });
        setTimeout(() => {
          this.setState({ notification: false, message: "" });
          this.getAllLevels(this.state.page_no, this.state.per_page);
        }, 2500);
      })
      .catch((err) => {
        this.setState({
          notification: true,
          noticolor: "error",
          message: err?.response?.data?.message || "Unable to delete AR level.",
        });
        setTimeout(() => this.setState({ notification: false, message: "" }), 2500);
      });
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/signin" replace />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                AR Levels List
              </MDTypography>
            </MDBox>
            <Grid item sm={4} px={2} align="right">
              <Link to="/add-ar-level">
                <MDButton variant="contained" size="small" color="primary">
                  Create AR Level
                </MDButton>
              </Link>
            </Grid>
            <MDBox>
              <DataTable
                table={{
                  columns: [
                    { Header: "serial", accessor: "serial", width: "6%" },
                    { Header: "name", accessor: "name" },
                    { Header: "subject", accessor: "subject" },
                    { Header: "topic", accessor: "topic" },
                    { Header: "action", accessor: "action" },
                  ],
                  rows: this.state.rows.map((job, index) => ({
                    serial: (this.state.page_no - 1) * this.state.per_page + index + 1,
                    name: `${job.level_name} (${job.level_type})`,
                    subject: job?.subject_id?.subject_name || "-",
                    topic: job?.topic_id?.topic_name || "-",
                    action: (
                      <>
                        <div>
                          <Link to={`/update-ar-level/${job._id}`}>
                            <MDButton variant="outlined" size="small" color="success">
                              Update
                            </MDButton>
                          </Link>
                        </div>
                        <div>
                          <MDButton
                            variant="outlined"
                            size="small"
                            color="error"
                            style={{ marginTop: "1rem" }}
                            onClick={() => this.handleDelete(job._id)}
                          >
                            Delete
                          </MDButton>
                        </div>
                      </>
                    ),
                  })),
                }}
                entriesPerPage={{ defaultValue: this.state.per_page, entries: [10, 25, 50, 100] }}
                page_no={this.state.pagination?.page}
                totalPages={this.state.pagination?.totalPages}
                hasNextPage={this.state.pagination?.hasNextPage}
                hasPrevPage={this.state.pagination?.hasPrevPage}
                isnextPage={this.state.pagination?.nextPage}
                prevPage={this.state.pagination?.prevPage}
                totalDocs={this.state.pagination?.totalDocs}
                onPageChange={this.handlePageChange}
                onEntriesPerPageChange={this.handleEntriesPerPageChange}
              />
            </MDBox>
            <MDSnackbar
              color={this.state.noticolor}
              icon="notifications"
              title="AgriQuiz"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
